import { Table, TablePaginationConfig } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Uniform } from '@/types'

type Props = {
  dataSource: Uniform[]
  getUniformsLoading: boolean
  page: number
  pageSize: number
  totalItems: number
  onChange: (config: TablePaginationConfig) => void
}

const UniformsTable = ({ dataSource, getUniformsLoading, page, pageSize, totalItems, onChange }: Props) => {
  const { t } = useTranslation()

  const columns = [
    {
      title: t('components.pages.uniforms.list.table.productCode'),
      dataIndex: 'productCode',
      key: 'productCode',
    },
    {
      title: t('components.pages.uniforms.list.table.productName'),
      dataIndex: 'productName',
      key: 'productName',
    },
    {
      title: t('components.pages.uniforms.list.table.size'),
      dataIndex: 'size',
      key: 'size',
    },
    {
      title: t('components.pages.uniforms.list.table.barcode'),
      dataIndex: 'barcode',
      key: 'barcode',
    },
    {
      title: t('components.pages.uniforms.list.table.code'),
      dataIndex: 'code',
      key: 'code',
    },
  ]

  return (
    <Table
      rowKey="id"
      dataSource={dataSource}
      columns={columns}
      loading={getUniformsLoading}
      pagination={{
        pageSize,
        current: page,
        total: totalItems,
      }}
      onChange={onChange}
    />
  )
}

UniformsTable.displayName = 'UniformsTable'
export default UniformsTable
